import TaxiCreditcard from '@/views/TaxiCreditcard/index.vue'

const TaxiCreditcardRouter = {
  path: '/taxi-creditcard',
  name: 'TaxiCreditcard',
  component: TaxiCreditcard,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default TaxiCreditcardRouter
